(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/marionette/radio.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/marionette/radio.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.radio = Backbone.Radio.channel('my-account');
  var LoginModel;
  svs.player_login.radio.reply('loginModel', function () {
    var serversideModels = svs.player_login.data || {};

    if (!LoginModel) {
      LoginModel = new svs.player_login.models.Login(serversideModels.login);
    }

    return LoginModel;
  });

  svs.player_login.radio.reply('autoStartToken', function (refresh, ssn) {
    var options = {
      method: 'POST',
      path: '/player/authenticate',
      data: {}
    },
        deferred = $.Deferred();
    svs.components.Storage.browser.set('loginStartTime', 'player-login', Date.now(), svs.components.Storage.constants.EXPIRES_10M, function () {}); 

    if (ssn) {
      options.data.personalId = ssn;
    }

    svs.core.jupiter.call(options, function (response) {
      deferred.resolve(response.autoStartToken);
    }, function (xhr, status, err) {
      svs.player_login.logger.error('Error starting bankid login', err);
      deferred.reject(xhr);
    });
    return deferred.promise();
  });

  svs.player_login.radio.reply('authRef', function () {
    var options = {
      method: 'POST',
      path: '/player/frejaeid/initauth',
      data: {}
    },
        deferred = $.Deferred();
    svs.components.Storage.browser.set('loginStartTime', 'player-login', Date.now(), svs.components.Storage.constants.EXPIRES_10M, function () {});
    svs.core.jupiter.call(options, function (response) {
      deferred.resolve(response.authRef);
    }, function (xhr, status, err) {
      svs.player_login.logger.error('Error starting Freja eID login', err);
      deferred.reject(xhr);
    });
    return deferred.promise();
  });
})(Backbone, _, svs);
 })(window);